import React, { useState, useEffect } from 'react';
import { SimpleTable, SimpleTableBody, SimpleTableData, SimpleTableWrapper, SimpleTableHead,
     SimpleTableHeader, SimpleTableContainer, SimpleTableRow, TOAST_POSITIONS, Toast,
    TOAST_VISIBILITY_DURATIONS, TOAST_VARIANTS } from 'cdk-radial';
import { clearToastNotification } from '../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { useSelector, useDispatch  } from 'react-redux';
import './ReviewActivations.css';



const ReviewActivations = () => {

    const [showToast, setShowToast] = useState(false);
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const dealershipData = state?.daabSubscriptionsSlice?.subscribeRequest;
    const errorSendingSubscribeRequest = state?.daabSubscriptionsSlice?.errorSendingSubscribeRequest;
    const toastVariant = TOAST_VARIANTS.NEGATIVE;
    const toastContent = 'Request for API Subscription is unsuccessful. Please try again after some time.'

    useEffect(() => {
      if (errorSendingSubscribeRequest) {
        setShowToast(true);
      }
    }, [errorSendingSubscribeRequest]);

    const formatDealer = (data) => {
        const departmentsMap = {};

        data.dmsConfig?.forEach((dms) => {
            if (!departmentsMap[dms.dmsType]) {
                departmentsMap[dms.dmsType] = [];
            }
            departmentsMap[dms.dmsType].push(dms.name);
        });

        const departments = Object.entries(departmentsMap).map(([name, dmsAccounts]) => ({
            name,
            dmsAccounts
        }));

        return {
            name: data.location,
            address: data.address,
            cmf: `CMF ${data.cmfNumber}`,
            departments
        };
    };

    return (
        <div style={{ width: "100%" }}>
            <div className='review-activations-text'>Review the details of your activations request.</div>
            {Object.values(dealershipData).map((dealer, index) => {
                const formatted = formatDealer(dealer);
                return (
                    <SimpleTableWrapper>
                        <SimpleTableContainer className="dealership-table" key={index}>
                            <SimpleTable>
                                <SimpleTableHead>
                                    <SimpleTableRow>
                                        <SimpleTableHeader className="cell-header">Dealership</SimpleTableHeader>
                                        {formatted.departments.length > 0 && (
                                            <>
                                                <SimpleTableHeader className="cell-header ">Departments</SimpleTableHeader>
                                                <SimpleTableHeader className="cell-header">DMS</SimpleTableHeader>
                                            </>
                                        )}
                                    </SimpleTableRow>
                                </SimpleTableHead>
                                <SimpleTableBody>
                                    {formatted.departments.length > 0 ? (
                                        formatted.departments.map((dept, deptIndex) => (
                                            dept.dmsAccounts.map((dms, dmsIndex) => (
                                                <SimpleTableRow
                                                    key={`${deptIndex}-${dmsIndex}`}
                                                    className={dmsIndex < dept.dmsAccounts.length - 1 ? 'intermediate-dms-row' : ''}>
                                                    {deptIndex === 0 && dmsIndex === 0 && (
                                                        <SimpleTableData className=" column-dealership" rowSpan={formatted.departments.reduce((acc, d) => acc + d.dmsAccounts.length, 0)}>
                                                            <div className='review-activations-dealership'>{formatted.name}</div>
                                                            <div className='review-activations-dealership-details'>{formatted.address}</div>
                                                            <div className='review-activations-dealership-details'>{formatted.cmf}</div>
                                                        </SimpleTableData>
                                                    )}
                                                    {dmsIndex === 0 && (
                                                        <SimpleTableData
                                                            className={`column-departments${formatted.departments.length - 1 === deptIndex ? ' last-department' : ''}`}
                                                            rowSpan={dept.dmsAccounts.length}
                                                        >
                                                            {dept.name} DMS Account
                                                        </SimpleTableData>
                                                    )}
                                                    <SimpleTableData
                                                        className={`column-dms ${dmsIndex === dept.dmsAccounts.length - 1 ? 'last-dms' : 'intermediate-dms'}`}
                                                    >
                                                        {dms}
                                                    </SimpleTableData>

                                                </SimpleTableRow>
                                            ))
                                        ))
                                    ) : (
                                        <SimpleTableRow>
                                            <SimpleTableData className=" column-dealership">
                                                <div className='review-activations-dealership'>{formatted.name}</div>
                                                <div className='review-activations-dealership-details'>{formatted.address}</div>
                                                <div className='review-activations-dealership-details'>{formatted.cmf}</div>
                                            </SimpleTableData>
                                        </SimpleTableRow>
                                    )}
                                </SimpleTableBody>
                            </SimpleTable>
                        </SimpleTableContainer>
                    </SimpleTableWrapper>
                );
            })}
            {showToast && (
                <Toast
                    variant={toastVariant}
                    content={toastContent}
                    id="activate-dealership-toast-notification"
                    onVisibilityDurationEnd={() => {
                        setShowToast(false);
                        dispatch(clearToastNotification());
                    }}
                    position={TOAST_POSITIONS.FIXED}
                    visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
                />
            )}
        </div>
    );
};

export default ReviewActivations;
